import getSetting from './settingsHelper'
import settingsEnums from '../../../helpers/enums/settings'
import viewTypes from '../../../helpers/enums/views'
import gameStates from '../../../helpers/enums/gameStates'
import { IStore } from '../../reducers/index'

const getGlobalGameState = (participants: any) => {
	const gameParticipants = participants
		.filter((participant: any) => participant.status === 1)
		.filter((participant: any) => participant.view.type === viewTypes.GAME)
	return gameParticipants.length > 0 &&
		gameParticipants.findIndex((participant: any) => participant.view.payload.isGameAnswered !== true) === -1
		? gameStates.ENDED
		: ''
}

const formatSync = (data: any) => {
	const globalGameState = getGlobalGameState(data.participants)

	const participants = data.participants.map((participant: any) => ({
		...participant,
		view: {
			...participant.view,
			payload: {
				...participant.view.payload,
				state:
					globalGameState ||
					(participant.view.payload && participant.view.payload.isGameAnswered
						? gameStates.ANSWERED
						: gameStates.WAITING),
			},
		},
	}))
	return participants
}

const formatOwnPaced = (data: any, state: IStore) => {
	const userId = state.app.playerUID
	const participantCurrentData = state.game.participants.find((participant: any) => participant.deviceUid === userId)

	const participants = data.participants.map((participant: any) => {
		let state = gameStates.WAITING
		if (participant.deviceUid === userId) {
			if (participantCurrentData) {
				if (
					(participantCurrentData.view.type === viewTypes.GAME &&
						(participant.view.type === viewTypes.WINNERS ||
							participantCurrentData.view.payload.currentActivityUid !==
								participant.view.payload.currentActivityUid)) ||
					participantCurrentData.view.payload.state === gameStates.TRANSITIONING
				) {
					state = gameStates.TRANSITIONING
				}
			}
			return {
				...participant,
				view: {
					...participant.view,
					payload: {
						...participant.view.payload,
						state,
					},
				},
			}
		} else {
			return participant
		}
	})
	return participants
}

const formatters = {
	[settingsEnums.SETTING_GAME_MODE_SYNC]: formatSync,
	[settingsEnums.SETTING_GAME_MODE_OWN_PACED]: formatOwnPaced,
}

const formatParticipants = (data: any, state: IStore) => {
	const gameModeSetting = getSetting(data.settings, settingsEnums.SETTING_TYPE_GAME_MODE) || {
		value: settingsEnums.SETTING_GAME_MODE_SYNC,
	}
	return formatters[gameModeSetting.value](data, state)
}

export default formatParticipants
